module.exports = __webpack_public_path__ + "static/media/buscar.1374e822.svg";